import { render, staticRenderFns } from "./MyExternalOrders.vue?vue&type=template&id=bf9c0492"
import script from "./MyExternalOrders.vue?vue&type=script&lang=js"
export * from "./MyExternalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports